import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const AuthContext = createContext();

/**
 * Respuesta esperada de la API externa:
 * { usuario, correo, token, url_imagen, roles: [], cod_compania: [] }
 */
export const AuthProvider = ({ children }) => {
  const [sesion, setSesion] = useState(() => {
    const guardado = localStorage.getItem('sesion');
    return guardado ? JSON.parse(guardado) : null;
  });

  const login = (data) => {
    // data = respuesta completa de la API externa
    localStorage.setItem('token', data.token);
    localStorage.setItem('sesion', JSON.stringify(data));
    setSesion(data);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('sesion');
    setSesion(null);
  };

  // Helpers de roles
  const tieneRol = (rol) => sesion?.roles?.includes(rol) ?? false;
  const esAdmin   = () => tieneRol('Administrador');
  const esBombero = () => sesion?.tipo === 'bombero_local' || sesion?.rol === 'bombero';

  return (
    <AuthContext.Provider value={{ sesion, login, logout, tieneRol, esAdmin, esBombero }}>
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useAuth = () => useContext(AuthContext);
